export const DOCUMENT_CATEGORY = 1;
export const TEXT_CATEGORY = 2;
export const CONTRACT_CATEGORY = 3;
export const CONTRACT_LABOR_CATEGORY = 4;

export const CONTRACT_TYPE_CATEGORY_LABOR = 2;
export const CONTRACT_TYPE_CATEGORY_PROFILE = 3;

export const IS_DEFAULT = 1;
export const IS_NOT_DEFAULT = 2;
